import { FeatureSelectorFieldProps } from "../types/feature-selector-field-props-type";

export const featureSelectorGetMapId = (props: FeatureSelectorFieldProps, mapSuffix: string) =>
  `${props.idSchema.$id}-${mapSuffix}`;
